export const SLEEP_CONSOLE_PATH = '/sleep-console';

export type WakeableEnvironment = 'davinci' | 'jarvis';

export const ENVIRONMENTS: { value: WakeableEnvironment; label: string; description: string }[] = [
  { value: 'davinci', label: 'Davinci', description: 'davinci non-production' },
  { value: 'jarvis', label: 'Jarvis', description: 'jarvis non-production' },
];

/**
 * Fixed choices rather than free entry. The scheduler refuses anything above ten
 * hours outright instead of clamping, so an input that can express eleven is an
 * input that can only disappoint.
 *
 * An hour is the shortest offered: waking takes about ten minutes, so anything
 * less is mostly spent waiting for the environment to answer.
 */
export const WAKE_HOURS = [1, 2, 4, 8, 10];
